import React, { useEffect, useState } from 'react';
import { isDefinedAndNotEmpty } from 'utils';

import Button from './Button';

const Pagination = (props) => {
  const { classes, pagination, onPaged } = props;

  const [settedPage, setPage] = useState(1);

  useEffect(() => {
    localStorage.setItem(
      'savedCurrentPage',
      JSON.stringify(pagination.current_page)
    );
    localStorage.setItem(
      'currentPathname',
      JSON.stringify(window.location.pathname.toString())
    );

    const localPathName = JSON.parse(localStorage.getItem('currentPathname'));

    if (localPathName === window.location.pathname.toString()) {
      if (Object.keys(localStorage.getItem('savedCurrentPage').length > 0)) {
        setPage(Number(localStorage.getItem('savedCurrentPage')));
      } else {
        localStorage.setItem('savedCurrentPage', JSON.stringify(1));
      }
    }
  }, [pagination, window.location]);

  useEffect(() => {
    if (
      isDefinedAndNotEmpty(settedPage) &&
      !isNaN(settedPage) &&
      settedPage !== 1
    ) {
      onPaged(settedPage);
    }
  }, [settedPage]);

  const renderItems = (pagination) => {
    let pages = Array(pagination.num_pages).fill(0, 0, pagination.num_pages);
    return pages.map((page, i) => {
      let index = i + 1;
      return (
        <Button
          key={index}
          classes={`pagination-item ${
            Number(settedPage) === index ? 'active' : ''
          }`}
          onClick={() => onPaged(index)}
        >
          {index}
        </Button>
      );
    });
  };

  return (
    pagination.num_pages > 1 && (
      <div className={'pagination ' + (classes ? classes : '')}>
        {renderItems(pagination)}
      </div>
    )
  );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/theme/Pagination.js